import styled, { css } from 'styled-components';
import { layout } from '../../../package.json';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  width: 100vw;
  height: 100%;
`;

export const ContainerBody = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;

  width: 80vw;
  height: 100%;
  min-height: 500px;
  margin-top: 16px;

`;

export const ContainerLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  width: 25%;
  height: 100%;
`;

export const ContainerMenu = styled.div`
  min-height: 500px;

`;

interface ContainerMenuItemProps {
  active?: boolean;
}

export const ContainerMenuItem = styled.div<ContainerMenuItemProps>`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  border: 1px solid var(--primary);
  margin-bottom: 6px;
  border-radius: 6px;
  cursor: pointer;

  ${props => props.active === true &&
    css`
      background-color: var(--primary);
    `}


  span {
    text-align: center;
    line-height: 50px;
    margin-left: 16px;
    ${props => props.active === false &&
    css`
        color: var(--primary);
      `}

      ${props => props.active === true &&
    css`
        color: #fff;
      `}

    svg {
      padding-top: 5px;
      font-size: 30px;
    }
  }

  div {
    width: 34px;
    height: 34px;
    margin-top: 34px;
    margin-right: -9px;
    border-radius: 3px;
    justify-content: center;
    transform-origin: 0px 0px;
    transform: rotate(-45deg);

    ${props => props.active === true &&
    css`
      background-color: #fff;
    `}

  }

  :hover{

    background-color: var(--primary);

    span {
      color: #fff;
    }

  }

`;

export const ContainerRight = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  width: 80%;
  min-height: 500px;
  border: 1px solid var(--primary);
  margin-left: 25px;
  border-radius: 8px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;

  span {
    font-size: 24px;
  }
`;

export const ContainerForm = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
`;

interface FormLineProps {
  width?: string;
}


export const FormLine = styled.div<FormLineProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 30rem;
  margin-left: 16px;
  margin-bottom: 16px;

  ${props => props.width && css`
    width: ${props.width};
  `}
`;

export const FormInputGroup = styled.div`
  width: 100%;
  form {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (max-width: ${layout.desktop}) {
    flex-direction: column;
  }
    }
`;

export const FormInputTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;

  margin-bottom: 8px;
`;

export const FormInput = styled.input`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  background-color: #fff;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid var(--primary);
  font-size: 16px;
`;

interface ContainerFooterProps {
  borderTop?: boolean;
}

export const ContainerFooter = styled.div<ContainerFooterProps>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 70px;

  padding-right: 16px;

  ${props => props.borderTop && css`
    border-top: 1px solid var(--primary);
  `}

`;

interface ButtonProps {
  typeStep: 'success' | 'danger' | 'alert' | 'warnig';
  active?: boolean;
  width?: string;
}

export const Button = styled.button<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 15px;

  width: 166px;
  height: 56px;

  border-radius: 6px;
  margin-left: 16px;

  :active{
    opacity: 0.7;
  }

  span {
    color: #fff;
    font-size: 18px;
  }

  ${props => props.typeStep === 'success' && css`
    background-color: #069751;
  `}

  ${props => props.typeStep === 'danger' && css`
    background-color: #D93209;
  `}

  ${props => props.typeStep === 'alert' && css`
    background-color: #1A22E0;
  `}

  ${props => props.typeStep === 'warnig' && css`
    background-color: #E9B01E;
  `}

  ${props => props.active === true && css`
    opacity: 0.7;
  `}
`;
